import { LicenseInfo } from '@mui/x-license';

export function setupMuiLicense() {
  const key = import.meta.env.VITE_MUI_LICENSE_KEY;
  if (key) {
    LicenseInfo.setLicenseKey(key);
  }
}
